import { useEffect } from 'react';

interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  structuredData?: Record<string, unknown>;
}

export default function SEO({ data }: { data: SEOData }) {
  useEffect(() => {
    document.title = data.title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', data.description);
    setMeta('keywords', data.keywords);
    setMeta('og:title', data.title, true);
    setMeta('og:description', data.description, true);
    setMeta('og:type', data.ogType || 'website', true);
    if (data.ogImage) {
      setMeta('og:image', data.ogImage, true);
    }
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', data.title);
    setMeta('twitter:description', data.description);

    // Canonical
    if (data.canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', data.canonicalUrl);
    }

    // Structured Data
    if (data.structuredData) {
      let script = document.querySelector('#structured-data');
      if (!script) {
        script = document.createElement('script');
        script.setAttribute('id', 'structured-data');
        script.setAttribute('type', 'application/ld+json');
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(data.structuredData);
    }

    return () => {
      // Cleanup structured data
      const script = document.querySelector('#structured-data');
      if (script) script.remove();
    };
  }, [data]);

  return null;
}